import type { Dispatch, GetState, MediaEngine } from 'state/types';
import { getAdminSession, getIdentitySession } from 'state/selectors';
import { actions as serverActions } from 'state/reducers/serverReducer';
import { actions as adminPropertiesActions } from 'state/reducers/serverReducer';
import { ADMIN_PROPERTIES } from 'util/AdminProperties';
import {
  addNotification,
  ERROR_LEVEL,
  SUCCESS_LEVEL,
} from 'portfolio-shared/state/commands/globalNotificationsCommands';
import localizedStrings from 'util/localizedStrings';
import logger from 'portfolio-shared/util/logging';

const {
  clearMediaEngineTestPending,
  createMediaEngine: createMediaEngineAction,
  deleteMediaEngine: deleteMediaEngineAction,
  setMediaEngineTestPending,
  testMediaEngine: testMediaEngineAction,
  updateMediaEngine: updateMediaEngineAction,
} = serverActions;

const { getAdminProperties: getAdminPropertiesAction } = adminPropertiesActions;

export function createMediaEngine(mediaEngine: MediaEngine) {
  return async function createMediaEngine(
    dispatch: Dispatch,
    getState: GetState
  ) {
    const adminSession = getAdminSession(getState());
    const identitySession = getIdentitySession(getState());
    if (identitySession) {
      await dispatch(
        createMediaEngineAction(identitySession, mediaEngine)
      ).catch(e => {
        logger.error(e);
        dispatch(
          addNotification(
            localizedStrings.NOTIFICATION_FAILURE_ADD,
            ERROR_LEVEL
          )
        );
      });
      dispatch(
        getAdminPropertiesAction(adminSession, identitySession, [
          ADMIN_PROPERTIES.mediaEngines,
        ])
      );
    }
  };
}

export function deleteMediaEngine(mediaEngineId: string) {
  return async function deleteMediaEngine(
    dispatch: Dispatch,
    getState: GetState
  ) {
    const adminSession = getAdminSession(getState());
    const identitySession = getIdentitySession(getState());
    if (identitySession) {
      await dispatch(deleteMediaEngineAction(identitySession, mediaEngineId));
      dispatch(
        getAdminPropertiesAction(adminSession, identitySession, [
          ADMIN_PROPERTIES.mediaEngines,
        ])
      );
    }
  };
}

export function testMediaEngine(
  mediaEngine: MediaEngine,
  operationalMsg,
  notOperationalMsg
) {
  return async function testMediaEngine(
    dispatch: Dispatch,
    getState: GetState
  ) {
    const session = getIdentitySession(getState());
    if (session) {
      dispatch(setMediaEngineTestPending());
      const { payload } = await dispatch(
        testMediaEngineAction(session, mediaEngine)
      );
      dispatch(clearMediaEngineTestPending());
      if (payload.isOperational) {
        dispatch(addNotification(operationalMsg, SUCCESS_LEVEL));
      } else {
        dispatch(addNotification(notOperationalMsg, ERROR_LEVEL));
      }
    }
  };
}

export function updateMediaEngine(
  mediaEngine: MediaEngine,
  notOperationalMsg: string
) {
  return async function updateMediaEngine(
    dispatch: Dispatch,
    getState: GetState
  ) {
    const adminSession = getAdminSession(getState());
    const identitySession = getIdentitySession(getState());
    if (identitySession) {
      let testFailed = false;
      // if we're enabling a ME, test it before enabling it
      if (mediaEngine.enabled) {
        const { payload } = await dispatch(
          testMediaEngineAction(identitySession, mediaEngine)
        );
        testFailed = !payload || !payload.isOperational;
      }

      if (testFailed) {
        dispatch(addNotification(notOperationalMsg, ERROR_LEVEL));
      } else {
        await dispatch(updateMediaEngineAction(identitySession, mediaEngine));
        dispatch(
          getAdminPropertiesAction(adminSession, identitySession, [
            ADMIN_PROPERTIES.mediaEngines,
          ])
        );
      }
    }
  };
}



// WEBPACK FOOTER //
// ./src/state/commands/mediaEngineCommands.js